import axios from 'axios';

const gptAppOrigin = process.env.VUE_APP_GPT_ORIGIN;
const gptPrefix = 'api';

const origin = `${process.env.VUE_APP_ORIGIN}`;
const prefix = 'api';
const chatbotSuggestionsUrl = `${origin}/${prefix}/chatbot-suggestions`;
const aiCaseUrl = `${origin}/${prefix}/ai-case`;
const aiCaseConfigUrl = `${origin}/${prefix}/ai-case/config`;

const routes = {
  post: {
    completion: `${gptAppOrigin}/${gptPrefix}/gpt/completion`,
    chatbotSuggestionsActive: `${chatbotSuggestionsUrl}/active`,
    chatbotSuggestionsAutoReplyActive: `${chatbotSuggestionsUrl}/auto-reply-active`,
    chatbotSuggestionsOffHoursAutoReplyActive: `${chatbotSuggestionsUrl}/off-hours-auto-reply-active`,
    chatbotSuggestionsDelay: `${chatbotSuggestionsUrl}/delay`,
    chatbotSuggestionsAiCaseDelay: `${chatbotSuggestionsUrl}/ai-case-delay`,
    aiCaseConfig: aiCaseConfigUrl,
  },
  get: {
    chatbotSuggestion: chatbotSuggestionsUrl,
    latestChatbotSuggestions: `${chatbotSuggestionsUrl}/latest`,
    aiCase: aiCaseUrl,
    aiCaseConfig: aiCaseConfigUrl,
  },
};

const gptApiCode = process.env.VUE_APP_GPT_API_CODE;

const getGptResponse = ({ chatId, messageIds, supportName }) => {
  const url = routes.post.completion;
  const data = {
    chat_id: chatId,
    message_ids: messageIds,
    support_name: supportName,
  };
  return axios.post(url, data, {
    params: { code: gptApiCode },
  });
};

const getPreGeneratedGptSuggestion = ({ chatId, messageId }) => {
  let params = `?${new URLSearchParams({ chatId, messageId }).toString()}`;

  const url = routes.get.chatbotSuggestion + params;
  return axios.get(url);
};

const getLatestChatbotSuggestions = () => {
  const url = routes.get.latestChatbotSuggestions;
  return axios.get(url);
};

const getChatbotSuggestionsActive = () => {
  const url = routes.post.chatbotSuggestionsActive;

  return axios.get(url);
};

const setChatbotSuggestionsActive = ({ active = false }) => {
  const url = routes.post.chatbotSuggestionsActive;
  const data = {
    active,
  };

  return axios.post(url, data);
};

const getChatbotSuggestionsAutoReplyActive = () => {
  const url = routes.post.chatbotSuggestionsAutoReplyActive;

  return axios.get(url);
};

const setChatbotSuggestionsAutoReplyActive = ({ autoReplyActive = false }) => {
  const url = routes.post.chatbotSuggestionsAutoReplyActive;
  const data = {
    autoReplyActive,
  };

  return axios.post(url, data);
};

const getChatbotSuggestionsOffHoursAutoReplyActive = () => {
  const url = routes.post.chatbotSuggestionsOffHoursAutoReplyActive;

  return axios.get(url);
};

const setChatbotSuggestionsOffHoursAutoReplyActive = ({
  offHoursAutoReplyActive = false,
}) => {
  const url = routes.post.chatbotSuggestionsOffHoursAutoReplyActive;
  const data = {
    offHoursAutoReplyActive,
  };

  return axios.post(url, data);
};

const getChatbotSuggestionsDelay = () => {
  const url = routes.post.chatbotSuggestionsDelay;

  return axios.get(url);
};

const setChatbotSuggestionsDelay = ({ delay = 70 }) => {
  const url = routes.post.chatbotSuggestionsDelay;
  const data = {
    delay,
  };

  return axios.post(url, data);
};

const getChatbotSuggestionsAiCaseDelay = () => {
  const url = routes.post.chatbotSuggestionsAiCaseDelay;

  return axios.get(url);
};

const setChatbotSuggestionsAiCaseDelay = ({ aiCaseDelay = 5 }) => {
  const url = routes.post.chatbotSuggestionsAiCaseDelay;
  const data = {
    aiCaseDelay,
  };

  return axios.post(url, data);
};

const getAiCase = ({ chatId }) => {
  let params = `?${new URLSearchParams({ chatId }).toString()}`;

  const url = routes.get.aiCase + params;
  return axios.get(url);
};

const getAiCaseConfig = () => {
  const url = routes.get.aiCaseConfig;

  return axios.get(url);
};

const setAiCaseConfig = enabled => {
  const url = routes.post.aiCaseConfig;
  const data = {
    enabled,
  };

  return axios.post(url, data);
};

export default {
  getGptResponse,
  getPreGeneratedGptSuggestion,
  getLatestChatbotSuggestions,
  getChatbotSuggestionsActive,
  setChatbotSuggestionsActive,
  getChatbotSuggestionsAutoReplyActive,
  setChatbotSuggestionsAutoReplyActive,
  getChatbotSuggestionsOffHoursAutoReplyActive,
  setChatbotSuggestionsOffHoursAutoReplyActive,
  getChatbotSuggestionsDelay,
  setChatbotSuggestionsDelay,
  getChatbotSuggestionsAiCaseDelay,
  setChatbotSuggestionsAiCaseDelay,
  getAiCase,
  getAiCaseConfig,
  setAiCaseConfig,
};
